angular.module('unergie.main')
.factory('AmountService', () => {
    const encodeToCents = (number) => Number(number) * 100
    const decodeFromCents = (number) => Number(number) / 100
    const sumBy = (numbers) => decodeFromCents(_.sumBy(_.compact(numbers), encodeToCents))

    return {
        encodeToCents,
        decodeFromCents,
        sumBy,
    }
})
